import React from "react";
import moment from "moment";
import NotificationController from "../../../stories/_setting/Notifications/NotificationController";
import "moment/locale/fr";
moment.locale('fr');

const Notification = props => {
    const { notification, refresh } = props;
    let alwaysIn = false;

    const over = () => {
        if (!alwaysIn) {
            alwaysIn = true;
            setTimeout(read, 500);
        }
    }
    const leave = () => {
        alwaysIn = false
    }
    const read = () => {
        if (notification.read === 1 || !alwaysIn)
            return;

        const controller = new NotificationController();
        controller._callback = returnRead;
        controller.read(notification.id);
        refresh(notification.id);
    }
    const returnRead = (error, status) => {
        switch (status) {
            default: break;
        }
    }

    return (
        <div className={"notification"} onMouseOver={over} onMouseLeave={leave}>
            <div className={"body"}>
                <p className={"message"}>{ notification.message }</p>
                <p className={"date"}>{ moment.utc(notification.created_at).local().fromNow()} </p>
            </div>
            {
                notification.read === 0
                && <div className={"unread"} />
            }
        </div>
    );
}

export default Notification;